<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.roleId ? (isEdit ? '编辑角色' : '查看角色') : '新增角色'" v-bind="$attrs"
    v-on="$listeners">
    <div class="edit-box flex-c-e"
      v-show="baseForm.roleId && baseForm.isSystem === '0'">
      <el-button v-if="hasPermi(['system:role:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child" v-closeSelect>
      <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
        :disabled="!!(!isEdit && baseForm.roleId)" label-width="120px">
        <el-form-item class="half" label="角色名称" prop="roleName">
          <el-input v-model.trim="dialogForm.roleName" clearable placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item class="half order" label="排序" key="order" prop="order">
          <el-input-number v-model="dialogForm.order" :min="1" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item class="all" label="备注" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.roleId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.roleId || isEdit">确 定</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import { roleApi } from "@/api"
export default {
  name: "RoleDialog",
  props: {
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    // 配置数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    /** 检查用户名是否已存在 */
    const checkroleName = (rule, value, callback) => {
      roleApi
        .judgeExist({ roleName: value, roleId: this.baseForm.roleId })
        .then((data) => {
          if (data.validateResult) {
            callback()
          } else {
            callback(data.msg)
          }
        })
    }
    return {
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { validator: checkroleName, trigger: "blur" }
        ],
        order: [{ required: true, message: "请输入排序", trigger: "change" }]
      }
    }
  },
  watch: {
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.dialogForm = JSON.parse(JSON.stringify(this.baseForm))
    },
    // 重置表单
    resetForm() {
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate((valid) => {
        if (valid) {
          //更新
          if (this.dialogForm.roleId) {
            roleApi.updateItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("编辑角色成功")
              this.$emit("close")
              this.$emit("successs")
            })
          } else {
            //新增
            roleApi.createItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("新增角色成功")
              this.$emit("close")
              this.$emit("successs")
            })
          }
        }
      })
    }
  }
}
</script>
